<template>
<span class="clickable" v-if="value === true"><i class="glyphicon glyphicon-ok" /><span style="display: none;">ja richtig wahr yes</span> </span>
<span class="clickable" v-else-if="value === false"><i class="glyphicon glyphicon-remove" /> <span style="display: none;">falsch nein no</span></span>
<span class="clickable" v-else-if="$te(scope+'.'+value)"> {{$t(scope+'.'+value)}}  </span>
<span class="clickable" v-else-if="typeof link !== 'undefined'"> <router-link :to="link">{{value}}</router-link></span>
<span class="clickable" v-else> {{value}} </span>
</template>

<script>
export default {
  name: "StaticOutput",
  data() {
    return {
    };
  },
  props: ["value", "scope", "link"],  
};
</script>

<style scoped>
.clickable {
	min-height: 10px;
	min-width: 50px; 
	display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/input/StaticOutput.vue